export const SALT_SYMMETRIC = 'salt-key-symmetric-';
export const SALT_SIGNING = 'salt-key-signing-';
export const SALT_ENCRYPTION = 'salt-key-encryption-';
export const SALT_SHARED = 'salt-shared-';

export const SALT_SIG_SIGNING = 'salt-sig-signing-';
export const SALT_SIG_ENCRYPTION = 'salt-sig-encryption-';
export const SALT_SIG_HASH = 'salt-sig-hash-';
export const SALT_SIG_SHARED = 'salt-sig-shared-';
